import {} from "@chakra-ui/react";

const breakpoints =  {
    md: "769px",
    lg: "1025px",
}

export {
    breakpoints
}